import React, { useEffect, useRef } from 'react';
import Flickity from 'flickity';

import 'flickity/css/flickity.css';

import slider1 from "../images/webinar-1.jpg"
import slider2 from "../images/webinar-2.jpg"
import slider3 from "../images/webinar-3.jpg"
import slider4 from "../images/webinar-4.jpg"

function ResourcesCarousel() {

  const flickityRef = useRef(null);

  useEffect(() => {
    const flickityInstance = new Flickity(flickityRef.current, {
      contain: true,
      wrapAround: true,
      imagesLoaded: true,
      pageDots: true,
    });

    flickityInstance.on('load', () => {
      console.log('Flickity carousel loaded!');
    });

    return () => {
      flickityInstance.destroy();
    };
  }, []);


  return (
    <div className="container max py-5">
        <div className="row pad-m-y pad-m-b">
          <h2 className="fw-bold compatil-bold color-1 text-center mb-5 mb">Webinar Resources</h2>
          {/* carousel */}
          <div className="carousel" ref={flickityRef}>
            <div className="carousel-cell">
              <a href="https://www.youtube.com/watch?v=H9LfUeT4HCA&t=3s" target="_blank" rel="noopener noreferrer">
                <img src={slider1} alt="" className="img-fluid" />
                <h4 className="open-sans color-1 my-3 text-center"><u>The Impact of Colonization and Infection on Vascular Devices</u></h4>
              </a>
            </div>
            <div className="carousel-cell">
              <a href="https://www.youtube.com/watch?v=drH3QwUq7UE&t=368s" target="_blank" rel="noopener noreferrer">
                <img src={slider2} alt="" className="img-fluid" />
                <h4 className="open-sans color-1 my-3 text-center"><u>The Clinical and Economic Impact of Central Venous Catheters</u></h4>
              </a>
            </div>
            <div className="carousel-cell">
              <a href="https://www.youtube.com/watch?v=QKV-u7WVrTs&list=PL75lb1atTs2YTLHvzch5Bqa86Xup3QJPQ&index=15&t=24s" target="_blank" rel="noopener noreferrer">
                <img src={slider3} alt="" className="img-fluid" />
                <h4 className="open-sans color-1 my-3 text-center"><u>The Arrow® All-in-One and One (Kit) For All Webinar</u></h4>
              </a>
            </div>
            <div className="carousel-cell">
              <a href="https://www.youtube.com/watch?v=NzV0ZcAUko4" target="_blank" rel="noopener noreferrer">
                <img src={slider4} alt="" className="img-fluid" />
                <h4 className="open-sans color-1 my-3 text-center"><u>Vascular Access Infection Reduction Strategies from the ED to the ICU Webinar</u></h4>
              </a>
            </div>
          </div>
        </div>
    </div>
  );
}

export default ResourcesCarousel;